import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "w-full tw timeentries bg-white overflow-auto print:overflow-hidden",
  style: {
    "left": "0px"
  }
};
const _hoisted_2 = {
  class: "container overflow-hidden tw color-unset lineheight-unset flex flex-col"
};
const _hoisted_3 = {
  class: "flex h-full w-full"
};
const _hoisted_4 = {
  class: "w-[3.625rem] px-2 bg-gray-50 no-print h-screen mt-3"
};
const _hoisted_5 = {
  class: "py-4"
};
const _hoisted_6 = {
  class: "p-1.5"
};
const _hoisted_7 = {
  class: "bg-gray-100 p-1 rounded-full border"
};
const _hoisted_8 = {
  class: "py-4"
};
const _hoisted_9 = {
  class: "py-4 border-b-2 border-gray-200",
  "data-cy": "m365-icon-sidebar"
};
const _hoisted_10 = {
  class: "py-4"
};
const _hoisted_11 = {
  key: 1,
  "data-cy": "calendar-icon-sidebar"
};
const _hoisted_12 = {
  key: 0,
  class: "w-[17rem] no-print rounded-lg mt-3 rounded-tl-none rounded-tr-[8px] rounded-br-[8px] rounded-bl-none"
};
const _hoisted_13 = {
  key: 1,
  class: "mt-3 rounded-tl-none rounded-tr-[8px] rounded-br-[8px] rounded-bl-none w-[17rem] px-2 pt-6 bg-gray-50 no-print"
};
const _hoisted_14 = {
  class: "flex py-2",
  "data-cy": "enable-m365-toggle"
};
const _hoisted_15 = {
  key: 2,
  class: "mt-3 rounded-tl-none rounded-tr-[8px] rounded-br-[8px] rounded-bl-none w-[17rem] px-2 pt-6 bg-gray-50 no-print"
};
const _hoisted_16 = {
  class: "flex justify-between px-6 py-4"
};
const _hoisted_17 = {
  class: "px-8 py-6"
};
const _hoisted_18 = {
  class: "flex flex-col justify-center p-4"
};
const _hoisted_19 = {
  class: "px-8 py-6"
};
const _hoisted_20 = {
  class: "py-2 no-print"
};
const _hoisted_21 = {
  class: "flex justify-between align-middle bg-white"
};
const _hoisted_22 = {
  class: "flex items-center"
};
const _hoisted_23 = {
  key: 0,
  class: "bg-green-50 rounded-md slim-border-green flex flex-row mr-4"
};
const _hoisted_24 = {
  class: "flex px-2 pt-0.5",
  "data-cy": "time-entry-experience-toggle"
};
const _hoisted_25 = {
  key: 0,
  "data-cy": "filters-container",
  class: "bg-green-50 pt-2 pb-4 rounded-lg no-print"
};
const _hoisted_26 = {
  class: "px-2 remove-all-input-styling"
};
const _hoisted_27 = {
  key: 0,
  class: "px-2"
};
const _hoisted_28 = {
  key: 1,
  class: "px-2 flex flex-col remove-all-input-styling"
};
const _hoisted_29 = {
  key: 0,
  class: "w-full"
};
const _hoisted_30 = {
  key: 2,
  class: "px-2 flex flex-col remove-all-input-styling tw"
};
const _hoisted_31 = {
  key: 1,
  class: "py-2 no-print",
  "data-cy": "insights-panel"
};
const _hoisted_32 = {
  class: "py-2"
};
const _hoisted_33 = {
  key: 0,
  class: "bg-white z-50 no-print inset-shadow-sm shadow-md rounded-lg mt-3 border border-gray-200 w-[25rem]"
};
import { onMounted, reactive, computed, ref, onUnmounted, nextTick, watch } from 'vue';
import LlSwitch from '@/components/LlSwitch.vue';
import EntryList from './EntryList.vue';
import InsightsHome from '@/modules/insights/InsightsHome.vue';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import TimekeeperPicker from '@/components/TimekeeperPicker.vue';
import LlBilledStatusSelect from '@/components/LlBilledStatusSelect.vue';
import FixedFeePicker from '@/components/FixedFeePicker.vue';
import LlCustomFlagSelect from '@/components/LlCustomFlagSelect.vue';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useEntriesStore } from '@/services/useEntriesStore';
import CodePicker from '@/components/CodePicker.vue';
import M356Logo from '@/components/SVG/M356Logo.vue';
import M365SmallLogo from '@/components/SVG/M365SmallLogo.vue';
import LLLogo from '@/components/SVG/LLLogo.vue';
import M356Cal from '@/components/SVG/M356Cal.vue';
import M365LogoWithSettings from '@/components/SVG/M365LogoWithSettings.vue';
import M365NewCalEvent from '@/components/SVG/M365NewCalEvent.vue';
import ListsService from '@/services/ListsService';
import Loader from '@/components/Loader.vue';
import M365Detail from './M365Detail.vue';
import EnableM365 from './EnableM365.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import EditEntry from '@/modules/time/EditEntry.vue';
import timeEntryModal from '@/modules/time/timeEntryModal.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { storeToRefs } from 'pinia';
import LlShowArchived from '@/components/LlShowArchived.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import useClientMatterStore from '@/services/useClientMatterStore';
import RouteService from '@/services/RouteService';
import { useSnackbarStore } from '@/services/snackbarStore';
import { useTimeEntryFormStore } from '@/services/useTimeEntryFormStore';
import { useTimeEntryShortcuts } from '@/composables/useTimeEntryShortcuts';
import { timeEntryShortcuts, getShortcutTooltip } from '@/constants/keyboardShortcuts';
import EventTracker from '@/services/eventTracker';
import { TrackingAction, TrackingCategory, TrackingPageType, FilterType } from '@/constants/trackingConstants';
import { ENTRY_PAGE_SIZES, DEFAULT_ENTRY_PAGE_SIZE } from './constants/timeEntryPagingConstants';
const __default__ = {
  name: 'Time',
  uiView: 'edit'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    snippetService: {
      type: Object,
      required: true
    },
    entryEditService: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    clientMatterManager: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      terms,
      permissions,
      settings,
      me,
      features
    } = storeToRefs(useMeStore());
    const {
      getMe,
      updateMe
    } = useMeStore();

    // Read at setup too, not only once onMounted's requests return: DateRangeSelect sets its
    // starting range on mount, and that triggers the first load before then.
    const savedPageSize = () => {
      const saved = settings.value?.timeEntryColumns?.pageSize;
      return ENTRY_PAGE_SIZES.includes(saved) ? saved : DEFAULT_ENTRY_PAGE_SIZE;
    };
    const {
      companySettings,
      customFlagLabel
    } = storeToRefs(useCompanyStore());
    const {
      loadMyCompany
    } = useCompanyStore();
    const {
      switchToDashboardView,
      listAccounts
    } = useAccountsStore();
    const listsService = new ListsService();
    const entriesStore = useEntriesStore();
    const {
      externalEventsList
    } = storeToRefs(useEntriesStore());
    const {
      listCharges
    } = useChargesStore();
    const {
      getMatterById
    } = useClientMatterStore();
    const props = __props;
    const routeService = new RouteService(props);
    const snackbarStore = useSnackbarStore();
    const timeEntryFormStore = useTimeEntryFormStore();

    // Keyboard shortcuts management
    let keyboardShortcuts = null;
    let trackTimeEntryCreation = () => {}; // Default no-op function

    const initializeKeyboardShortcuts = () => {
      // Clean up existing shortcuts first
      if (keyboardShortcuts) {
        keyboardShortcuts.removeKeyboardListener();
        keyboardShortcuts = null;
      }

      // Only initialize if feature flag is enabled
      if (features.value?.enableTimeEntryShortcuts) {
        keyboardShortcuts = useTimeEntryShortcuts({
          onCreateTimeEntry: params => {
            createNewTimeEntry({
              isBulkCreate: true,
              ...params
            });
          },
          onCancel: () => {
            closePanels();
          },
          tracking: props.tracking,
          enableGlobalShortcuts: true
        }); // Manually setup keyboard listener (avoid Vue lifecycle issues)
        keyboardShortcuts.setupKeyboardListener();
        trackTimeEntryCreation = keyboardShortcuts.trackTimeEntryCreation;
      }
    };

    // Watch for feature flag changes
    watch(() => features.value?.enableTimeEntryShortcuts, () => {
      initializeKeyboardShortcuts();
    }, {
      immediate: true
    });
    const vm = reactive({
      showFilters: true,
      M365Settings: false,
      isM365Enabled: false,
      showDisableDialog: false,
      showInsights: false,
      loading: false,
      filter: {
        range: {
          range: {
            startDate: null,
            endDate: null
          }
        },
        cm: {
          client: null,
          matter: null
        },
        codes: {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        },
        account: {},
        charge: null,
        fixedFeeAssignment: null,
        ffSelection: null,
        limit: savedPageSize(),
        pageSize: savedPageSize(),
        offset: 0,
        search: '',
        orderBy: null,
        order: null,
        shortDescriptions: false,
        showStartStopTimes: false,
        showInternalNotes: false,
        showTaskCodes: false,
        showActivityCodes: false,
        showFixedFeeColumn: true,
        archived: {
          label: 'Exclude Archived',
          status: 'active'
        }
      },
      accounts: [],
      headers: [],
      fixedFeeList: [],
      ffLoading: false,
      entryLoading: false,
      showEnableDetail: false,
      showEnableModel: false,
      showEditModal: false,
      isModalExpanded: false,
      params: {},
      isPrinting: false
    });

    // Reactive screen width tracking with debouncing
    const screenWidth = ref(window?.innerWidth || 1366);
    const resizeTimeout = ref(null);
    const isResizing = ref(false);
    const clientMatterSearchRef = ref(null);
    const m365Loading = ref(false);

    // Optimized window resize listener with debouncing
    const handleResize = () => {
      isResizing.value = true; // Immediately flag that we're resizing

      if (resizeTimeout.value) {
        clearTimeout(resizeTimeout.value);
      }

      // Debounce the resize to prevent excessive updates
      resizeTimeout.value = setTimeout(() => {
        screenWidth.value = window.innerWidth;
        isResizing.value = false; // Clear flag when resize is complete
      }, 100); // 100ms debounce
    };
    const cmQueryFilter = computed(() => {
      return {
        scopeAccount: vm.filter.account ? vm.filter.account.id : null,
        originating: false,
        involved: vm.filter.account ? true : false,
        reviewer: false,
        primary: false,
        archived: false
      };
    });
    const entryListRef = ref(null);

    // Every print (the Print button, Ctrl+P, the browser menu) passes through here. Panels
    // close because with one open on a narrower screen the list shows cards, which don't print.
    const handleBeforePrint = () => {
      closePanels();
      vm.isPrinting = true;
    };
    const handleAfterPrint = () => {
      vm.isPrinting = false;
    };
    onMounted(async () => {
      vm.loading = true;
      const accounts = await listAccounts();
      vm.accounts = accounts;
      await Promise.all([getMe(true), loadMyCompany()]);
      /**
       * Temporary fallback mechanism that redirects users to the legacy time entries page
       * when they haven't enabled the new time entry feature, or for historic users
       * who don't have access to this feature yet.
       * Exception: Trial firms automatically get access to the new time entry experience.
       */
      const enableNewTimeEntry = me.value.settings?.enableNewTimeEntry ?? false;
      const isTrialFirm = me.value?.company?.subscription?.trial || false;

      // For trial firms: Automatically enable the new experience if not already enabled
      if (isTrialFirm && !enableNewTimeEntry) {
        try {
          await updateMe({
            settings: {
              enableNewTimeEntry: true
            }
          });

          // Track that we automatically enabled the new experience for a trial firm
          if (props.tracking) {
            props.tracking.event('Toggle', 'SlideInTimeEntry', {
              enableNewTimeEntry: true,
              autoEnabled: true,
              reason: 'trialFirm'
            });
          }
        } catch (err) {
          // If we can't update user settings, continue showing the new experience anyway
          console.error('Could not update user settings for trial firm:', err);
        }
      }

      // Redirect to legacy page only if: not enabled AND not a trial firm AND has the feature flag
      if (!enableNewTimeEntry && !isTrialFirm && features.value.timeEntriesTab) {
        routeService.go('timeentries');
      }
      if (settings?.value.insightsView) {
        vm.showInsights = true;
      } else {
        vm.showInsights = false;
      }

      // Initialize column visibility settings from user preferences
      initializeColumnVisibilitySettings();
      vm.filter.limit = vm.filter.pageSize;

      // Pre-apply URL filter params (e.g. from Fixed Fees page "Review Entries" link)
      applyUrlFilterParams();
      vm.filter.customFlag = {
        label: 'Include',
        id: 'any'
      };
      vm.filter.billed = {
        label: 'WIP',
        id: 'WIP'
      };

      // for non-operators/accountants, default to their own account
      // else timekeeper dropdown will be blank since this role doesn't create time entry for themselves
      // When navigating from Fixed Fees "Review Entries" banner, skip setting the timekeeper filter
      // for users with createOthers permission so they see ALL unassigned entries (not just their own)
      const skipTimekeeperDefault = props.stateParams?.fixedFeeAssignment === 'Unassigned' && permissions.value.time?.createOthers;
      if (!skipTimekeeperDefault && me.value.role !== 'operator' && me.value.role !== 'accountant') {
        vm.filter.account = me.value;
      }
      if (features.value.m365) {
        await listExternalEvents();
      }
      vm.showEnableDetail = vm.isM365Enabled && features.value.m365 && settings.value?.m365CalendarPanelVisible || false;

      // For 'allTime' (fixedFeeAssignment navigation) the value doesn't change,
      // so we call loadEntries explicitly to ensure data is fetched.
      if (initialDateRange.value === 'allTime') {
        await loadEntries();
      }
      vm.loading = false;

      // Add print event listeners
      window.addEventListener('beforeprint', handleBeforePrint);
      window.addEventListener('afterprint', handleAfterPrint);

      // Add window resize listener
      window.addEventListener('resize', handleResize);

      // Shortcuts are now managed by watcher
    });
    const tableHeaders = computed(() => {
      // Base headers that are always shown
      const headers = [{
        title: 'Date',
        align: 'start',
        key: 'date',
        headerProps: {
          'data-cy': 'date-column-header'
        }
      }, {
        title: 'Timekeeper',
        key: 'timekeeper'
      }, {
        title: 'Client',
        key: 'client'
      }, {
        title: `${terms.value?.Matter}`,
        key: 'matter'
      }, {
        title: 'Description',
        key: 'description'
      }, {
        title: 'Hours',
        key: 'hours',
        align: 'center',
        cellProps: {
          class: 'text-center'
        }
      }];

      // Conditionally add start/stop time columns
      if (vm.filter.showStartStopTimes) {
        headers.push({
          title: 'Start Time',
          key: 'startTime',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: false
        }, {
          title: 'Stop Time',
          key: 'endTime',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: false
        });
      }

      // Add Rate and Amount columns if permissions allow
      if (permissions.value.time?.viewRates) {
        headers.push({
          title: 'Rate',
          key: 'rate',
          align: 'center',
          cellProps: {
            class: 'text-center'
          }
        }, {
          title: 'Amount',
          key: 'amount',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: true
        });
      }

      // Add Billing Type column
      headers.push({
        title: 'Billing Type',
        key: 'billingType',
        align: 'center',
        cellProps: {
          class: 'text-center'
        }
      });

      // Conditionally add activity codes column 
      if (showLedesCodes.value && vm.filter.showActivityCodes) {
        headers.push({
          title: 'Activity Code',
          key: 'activityCode',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: true
        });
      }

      // Conditionally add task codes column
      if (showLedesCodes.value && vm.filter.showTaskCodes) {
        headers.push({
          title: 'Task Code',
          key: 'taskCode',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: true
        });
      }

      // Conditionally add custom flag column
      if (customFlagLabel.value) {
        headers.push({
          title: `${customFlagLabel.value}`,
          key: 'customFlag',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: false
        });
      }

      // Conditionally add fixed fee column
      if (vm.filter.showFixedFeeColumn && features.value?.centralizedFixedFeePage) {
        headers.push({
          title: 'Fixed Fee',
          key: 'fixedFee',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: false
        });
      }

      // Conditionally add notes column (last dynamic column)
      if (vm.filter.showInternalNotes) {
        headers.push({
          title: 'Notes',
          key: 'note',
          align: 'center',
          cellProps: {
            class: 'text-center'
          },
          sortable: true
        });
      }

      // Add actions column
      headers.push({
        title: '',
        key: 'actions',
        sortable: false
      });
      return headers;
    });
    const hasOptionalFilters = computed(() => {
      return showLedesCodes.value || features.value.archivedTimeEntryFilter || customFlagLabel.value || features.value?.centralizedFixedFeePage || vm.fixedFeeList.length > 0;
    });

    // Fix the visibleFilterCount computed property
    const visibleFilterCount = computed(() => {
      let count = 0;

      // Always visible: Date Range (1)
      count += 1;
      const hasOptional = hasOptionalFilters.value;
      if (hasOptional) {
        count += 1; // Client Matter
        count += 1; // TimeKeeper/Billed

        // Count actual visible optional filters
        if (showLedesCodes.value) {
          count += 1; // Code Picker
        }

        // Check if both Custom Flag AND FF filter are present
        const hasCustomFlag = customFlagLabel.value;
        const hasFFFilter = features.value?.centralizedFixedFeePage || vm.fixedFeeList.length > 0;
        const hasBothCustomAndFF = hasCustomFlag && hasFFFilter;
        if (hasCustomFlag || hasFFFilter) {
          count += 1; // Custom Flag/Fixed Fee column
        }
        if (features.value.archivedTimeEntryFilter) {
          if (hasBothCustomAndFF || !hasCustomFlag && !hasFFFilter) {
            count += 1; // Archived gets separate column
          }
        }
      } else {
        //When optionalfilter is absent, treat clientmatter and timekeeperbilled as different filter.
        count += 2; // Client Matter (spans 2)
        count += 2; // TimeKeeper/Billed (spans 2)
      }
      return count;
    });
    const filterGridClass = computed(() => {
      const count = visibleFilterCount.value;
      // Use Tailwind's built-in grid classes with fallback
      const gridClasses = {
        1: 'grid-cols-1',
        2: 'grid-cols-2',
        3: 'grid-cols-3',
        4: 'grid-cols-4',
        5: 'grid-cols-5',
        6: 'grid-cols-6'
      };
      return gridClasses[count] || 'grid-cols-1';
    });
    const accountChanged = async event => {
      vm.filter.account = event;
      // Explicitly call the ClientMatterSearch component's clear method
      if (clientMatterSearchRef.value) {
        await clientMatterSearchRef.value.clearClient();
      }
      reloadFromFirstPage();
    };

    /**
     * Unified FF filter change handler.
     * Determines whether the user selected an assignment status or a specific
     * charge and sets the appropriate filter properties for buildQuery().
     */
    let ffFilterTrackTimeout = null;
    const ffFilterChanged = value => {
      vm.filter.ffSelection = value;
      if (!value || value.id === 'All') {
        vm.filter.fixedFeeAssignment = null;
        vm.filter.charge = null;
      } else if (value.itemType === 'charge') {
        vm.filter.charge = {
          id: value.id,
          description: value.label
        };
        vm.filter.fixedFeeAssignment = null;
      } else {
        // assignment (Assigned / Unassigned)
        vm.filter.fixedFeeAssignment = value;
        vm.filter.charge = null;
      }

      // Debounced analytics event (300ms per BR-5)
      if (props.tracking) {
        clearTimeout(ffFilterTrackTimeout);
        ffFilterTrackTimeout = setTimeout(() => {
          let filterValue = 'all';
          if (value && value.id !== 'All') {
            filterValue = value.itemType === 'charge' ? value.label || value.id : (value.label || value.id || '').toLowerCase();
          }
          const payload = {
            filterType: FilterType.FIXED_FEE_ASSIGNMENT,
            filterValue,
            pageType: TrackingPageType.TIME_ENTRIES
          };
          EventTracker.trackEvent(props.tracking, TrackingCategory.TIME_ENTRIES, TrackingAction.FILTER_APPLIED, payload);
        }, 300);
      }
      reloadFromFirstPage();
    };
    const handleCodeChange = event => {
      vm.filter.codes = event;
      reloadFromFirstPage();
    };

    /** Legacy charge-only change handler (when centralizedFixedFeePage is off) */
    const chargeChanged = event => {
      vm.filter.charge = event;
      reloadFromFirstPage();
    };
    async function listExternalEvents() {
      const {
        m365
      } = (await entriesStore.externalEventsStatus()) || {};
      vm.isM365Enabled = m365;
      if (m365) {
        await entriesStore.listExternalEvents();
      }
    }
    async function loadEntries() {
      vm.entryLoading = true;
      await entriesStore.listEntries(vm.filter);
      vm.entryLoading = false;
    }

    // A changed filter is a new list: start it from the first entry at the user's page size.
    // That also ends Show All, whose size was the previous list's total.
    function reloadFromFirstPage() {
      vm.filter.offset = 0;
      vm.filter.limit = vm.filter.pageSize;
      loadEntries();
    }

    /**
     * Reads URL/route params and pre-applies filters.
     * Called once during onMounted, before the first loadEntries.
     * Currently supports:
     *   - fixedFeeAssignment: 'Unassigned' (also switches date range to All Time)
     */
    function applyUrlFilterParams() {
      const ffAssignment = props.stateParams?.fixedFeeAssignment;
      if (ffAssignment && ['Unassigned'].includes(ffAssignment)) {
        const filterObj = {
          label: ffAssignment,
          id: ffAssignment,
          itemType: 'assignment'
        };
        vm.filter.ffSelection = filterObj;
        vm.filter.fixedFeeAssignment = filterObj;
      }
    }

    // When navigating from Fixed Fees with a fixedFeeAssignment filter, show all entries
    // (not just this month) so the user sees the full unassigned/assigned picture.
    const initialDateRange = ref(props.stateParams?.fixedFeeAssignment ? 'allTime' : 'thisMonth');
    const matterChanged = async () => {
      vm.fixedFeeList = [];
      vm.filter.charge = null;

      // Auto-clear specific fee selection when client/matter changes (keep assignment selection)
      if (vm.filter.ffSelection?.itemType === 'charge') {
        vm.filter.ffSelection = null;
      }
      if (!vm.filter.cm.matter?.id) {
        reloadFromFirstPage();
        return;
      }
      const [matter] = await Promise.all([getMatterById(vm.filter.cm.matter?.id, true), getCharge(vm.filter.cm.matter?.id)]);
      vm.filter.cm.matter = matter;
      reloadFromFirstPage();
    };
    const getCharge = async matterId => {
      if (!matterId) {
        return;
      }
      vm.ffLoading = true;
      vm.fixedFeeList = await listCharges({
        matterId,
        billed: 'any'
      });
      vm.ffLoading = false;

      // Auto-select the only fee unless the user already has an assignment filter active
      const hasAssignmentFilter = vm.filter.ffSelection && vm.filter.ffSelection.itemType !== 'charge';
      if (vm.fixedFeeList?.length === 1 && !hasAssignmentFilter) {
        const fee = vm.fixedFeeList[0];
        vm.filter.charge = fee;
        vm.filter.ffSelection = {
          label: fee.description,
          id: fee.id,
          itemType: 'charge'
        };
      }
    };
    const toggleEnableDetail = async value => {
      if (!features.value.m365) {
        vm.M365Settings = false;
        return;
      }
      vm.M365Settings = false;
      if (!vm.isM365Enabled) {
        toggleEnableModel();
        return;
      }
      m365Loading.value = true;
      vm.showEnableDetail = value ?? !vm.showEnableDetail;
      await updateMe({
        settings: {
          m365CalendarPanelVisible: vm.showEnableDetail
        }
      });
      props.tracking.event('Toggle', 'M365CalendarPanel', {
        enablem365CalendarPanel: vm.showEnableDetail
      });
      m365Loading.value = false;
    };
    const toggleM365Settings = () => {
      vm.showEnableDetail = false;
      vm.M365Settings = !vm.M365Settings;
      m365Loading.value = false;
    };
    const toggleEnableModel = () => {
      vm.showEnableModel = !vm.showEnableModel;
    };
    const disableM365 = async () => {
      const response = await entriesStore.disableM365();
      if (response) {
        vm.showDisableDialog = false;
        const {
          m365
        } = (await entriesStore.externalEventsStatus()) || {};
        vm.isM365Enabled = m365;
        vm.M365Settings = false;
      }
    };
    const dateRangeFilterChanged = dateSelect => {
      vm.filter.range.range = dateSelect;
      reloadFromFirstPage();
    };
    const switchToInsightsHome = () => {
      vm.showInsights = !vm.showInsights;
      switchToDashboardView(vm.showInsights);
    };
    const createNewTimeEntry = async params => {
      const entryParams = params || {};
      if (vm.filter.cm.client) {
        entryParams.clientId = vm.filter.cm.client.id;
      }
      if (vm.filter.cm.matter) {
        entryParams.matterId = vm.filter.cm.matter.id;
      }
      if (vm.showEditModal && editEntryRef.value && editEntryRef.value.confirmDiscardChanges) {
        const proceed = await editEntryRef.value.confirmDiscardChanges('creating a new one');
        if (!proceed) {
          return;
        }
        vm.showEditModal = false;
        vm.params = {};
        await nextTick();
      }

      // Mark as a truly new entry to prevent restoration of old data
      entryParams.isNewEntry = true;
      entryParams.clearPersistedState = true;
      vm.params = entryParams;
      vm.showEditModal = true;
    };
    const editEntryRef = ref(null);
    const editTimeEntry = async params => {
      if (!params || typeof params !== 'object') {
        return;
      }
      // Force panel refresh if we're switching entries or duplicating
      const isDifferentEntry = vm.params?.entryId !== params.entryId;
      const isDuplicateOperation = params.duplicateEntryId;
      if (vm.showEditModal && (isDifferentEntry || isDuplicateOperation)) {
        if (editEntryRef.value && editEntryRef.value.confirmDiscardChanges) {
          const proceed = await editEntryRef.value.confirmDiscardChanges('selecting a different one');
          if (!proceed) {
            return;
          }
        }
        vm.showEditModal = false;
        vm.params = {};

        // Use nextTick to ensure DOM updates before opening new panel
        await nextTick();
        vm.params = {
          ...params
        };
        vm.showEditModal = true;
        return;
      }
      vm.params = {
        ...params
      };
      vm.showEditModal = true;
    };
    const addOrEditEntry = entry => {
      // If this is a deletion and we're in modal mode, just close the modal
      // but keep the panel state ready for next selection
      if (entry && entry.deleted && vm.isModalExpanded) {
        vm.isModalExpanded = false;
        // Clear params completely and close panel to ensure clean state
        vm.params = {};
        vm.showEditModal = false;

        // Force clear any persisted form state to prevent loading deleted entry
        timeEntryFormStore.clearFormState();
        return;
      }

      // For all other cases (save, cancel, deletion from panel), close everything
      vm.showEditModal = false;
      vm.params = {};

      // Handle external events if needed
      if (entry && entry.externalEvent) {
        listExternalEvents();
      }
    };
    const getMainContentClass = computed(() => {
      const basePanelWidth = vm.showEnableDetail || vm.M365Settings || vm.showEnableModel;
      const editPanelOpen = vm.showEditModal;
      const insightsOpen = vm.showInsights;
      const width = screenWidth.value;
      let classes = ['transition-all', 'duration-300', 'ease-in-out'];
      if (editPanelOpen && width >= 1024) {
        if (basePanelWidth) {
          if (insightsOpen) {
            classes.push('w-edit-panel-with-sidebar-insights');
          } else {
            classes.push('w-edit-panel-with-sidebar');
          }
        } else {
          if (insightsOpen) {
            classes.push('w-edit-panel-open-insights');
          } else {
            classes.push('w-edit-panel-open');
          }
        }
      } else {
        if (basePanelWidth) {
          if (insightsOpen) {
            classes.push('w-custom-insights');
          } else {
            classes.push('w-custom');
          }
        } else {
          if (insightsOpen) {
            classes.push('w-full-insights');
          } else {
            classes.push('w-full');
          }
        }
      }
      return classes.join(' ');
    });
    const closeEditPanel = () => {
      vm.showEditModal = false;
      vm.params = {};
    };
    const handleCloseEditPanel = entryId => {
      if (vm.showEditModal && vm.params.entryId === entryId) {
        closeEditPanel();
      }
    };
    const closePanels = () => {
      vm.showEditModal = false;
      vm.showEnableDetail = false;
      vm.M365Settings = false;
      vm.showEnableModel = false;
      vm.params = {};
    };
    const setPrintState = isPrinting => {
      vm.isPrinting = isPrinting;
    };
    onUnmounted(() => {
      // Clean up timers
      window.removeEventListener('resize', handleResize);
      if (resizeTimeout.value) {
        clearTimeout(resizeTimeout.value);
      }
      if (updateTimeout.value) {
        clearTimeout(updateTimeout.value);
      }
      if (ffFilterTrackTimeout) {
        clearTimeout(ffFilterTrackTimeout);
      }

      // Clean up keyboard shortcuts
      if (keyboardShortcuts) {
        keyboardShortcuts.removeKeyboardListener();
        keyboardShortcuts = null;
      }

      // Remove print event listeners
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    });
    // Toggle function to switch between new and old time entry experience
    const toggleOldTimeEntryUi = async () => {
      try {
        await updateMe({
          settings: {
            enableNewTimeEntry: false
          }
        });
        props.tracking.event('Toggle', 'SlideInTimeEntry', {
          enableNewTimeEntry: false
        });
        await props.userService.reset();
        routeService.go('timeentries');
      } catch (err) {
        props.alerts.error(err);
      }
    };
    const handleDuplicateEntry = params => {
      // If panel is already open with an entry, call the duplicate method directly
      if (vm.showEditModal && Object.keys(vm.params).length > 0 && editEntryRef.value) {
        // Call the duplicate method directly on the component instance
        editEntryRef.value.handleDuplicateRequest(params.duplicateEntryId);
        return;
      }

      // If no panel is open, proceed normally
      editTimeEntry(params);
    };
    const leftPanelOpen = computed(() => {
      return vm.showEnableDetail || vm.M365Settings || vm.showEnableModel;
    });
    const showLedesCodes = computed(() => {
      return companySettings.value.codes?.ledes && (!vm.filter?.cm?.matter || vm.filter?.cm?.matter?.client?.codes?.ledes);
    });

    // Check if the firm is in trial status
    const isFirmInTrial = computed(() => {
      return me.value?.company?.subscription?.trial || false;
    });

    // Column visibility settings persistence functions
    const initializeColumnVisibilitySettings = () => {
      const timeEntryColumns = settings.value?.timeEntryColumns || {};

      // Initialize with saved settings or defaults
      vm.filter.showStartStopTimes = timeEntryColumns.showStartStopTimes ?? false;
      vm.filter.showInternalNotes = timeEntryColumns.showInternalNotes ?? false;
      vm.filter.showTaskCodes = timeEntryColumns.showTaskCodes ?? false;
      vm.filter.showActivityCodes = timeEntryColumns.showActivityCodes ?? false;
      vm.filter.shortDescriptions = timeEntryColumns.shortDescriptions ?? false;
      vm.filter.showFixedFeeColumn = timeEntryColumns.showFixedFeeColumn ?? true;
      vm.filter.pageSize = savedPageSize();
    };

    // Simple debounced update - much cleaner approach
    const updateTimeout = ref(null);
    const updateColumnVisibilitySetting = async (settingName, value) => {
      // Update local state immediately for responsiveness
      vm.filter[settingName] = value;

      // Clear existing timeout
      if (updateTimeout.value) {
        clearTimeout(updateTimeout.value);
      }

      // Simple debounce - wait for user to stop clicking before saving
      updateTimeout.value = setTimeout(async () => {
        try {
          const currentTimeEntryColumns = settings.value?.timeEntryColumns || {};

          // Create updated settings with current UI state
          const updatedColumns = {
            ...currentTimeEntryColumns,
            showStartStopTimes: vm.filter.showStartStopTimes,
            showInternalNotes: vm.filter.showInternalNotes,
            showTaskCodes: vm.filter.showTaskCodes,
            showActivityCodes: vm.filter.showActivityCodes,
            shortDescriptions: vm.filter.shortDescriptions,
            showFixedFeeColumn: vm.filter.showFixedFeeColumn,
            pageSize: vm.filter.pageSize
          };
          await updateMe({
            settings: {
              timeEntryColumns: updatedColumns
            }
          });
        } catch (error) {
          // Revert to server state on error
          initializeColumnVisibilitySettings();
        }
      }, 300); // Shorter delay for better UX
    };

    // Export functions for EntryList to use
    const toggleStartStopTimes = value => updateColumnVisibilitySetting('showStartStopTimes', value);
    const toggleInternalNotes = value => updateColumnVisibilitySetting('showInternalNotes', value);
    const toggleTaskCodes = value => updateColumnVisibilitySetting('showTaskCodes', value);
    const toggleActivityCodes = value => updateColumnVisibilitySetting('showActivityCodes', value);
    const toggleShortDescriptions = value => updateColumnVisibilitySetting('shortDescriptions', value);
    const toggleFixedFeeColumn = value => updateColumnVisibilitySetting('showFixedFeeColumn', value);
    // The page size is saved with the column choices in settings.timeEntryColumns.
    const savePageSize = value => updateColumnVisibilitySetting('pageSize', value);

    // Optimized modal state management with minimal overhead
    const expandModal = () => {
      // Efficient state update without unnecessary parameters
      vm.isModalExpanded = true;
      vm.showEditModal = false;
    };
    const minimizeModal = async () => {
      // Batch state updates for better performance
      Object.assign(vm, {
        isModalExpanded: false,
        showEditModal: true
      });

      // Single nextTick for DOM updates, then let the store handle restoration
      await nextTick();

      // The EditEntry component will handle automatic restoration via watchers
      // No manual intervention needed - more reliable and performant
    };
    const closeExpandedModal = event => {
      vm.isModalExpanded = false;

      // Only close the edit panel if this is a normal close (not a deletion)
      // Deletions are handled by addOrEditEntry and should keep panel available
      if (!event || !event.deleted) {
        closeEditPanel();
      } else {
        // For deletions, just clear params but keep panel open for next selection
        vm.params = {};
      }
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SnackbarComponent), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_withDirectives(_createVNode(_component_v_icon, {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => {
          vm.M365Settings = true;
          toggleEnableDetail();
        }, ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("mdi-arrow-right", -1)]))]),
        _: 1
      }, 512), [[_vShow, !(vm.M365Settings || vm.showEnableDetail || vm.showEnableModel)]]), _withDirectives(_createVNode(_component_v_icon, {
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => {
          vm.M365Settings = false;
          toggleEnableDetail(false);
        }, ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("mdi-arrow-left", -1)]))]),
        _: 1
      }, 512), [[_vShow, vm.M365Settings || vm.showEnableDetail || vm.showEnableModel]])])])]), _withDirectives(_createElementVNode("div", _hoisted_8, [_createVNode(M365SmallLogo, {
        onClick: _cache[2] || (_cache[2] = $event => toggleEnableDetail()),
        class: "custom-shadow"
      })], 512), [[_vShow, !vm.isM365Enabled]]), _withDirectives(_createElementVNode("div", _hoisted_9, [_createVNode(M365LogoWithSettings, {
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => toggleM365Settings(), ["prevent"])),
        class: "custom-shadow"
      })], 512), [[_vShow, vm.isM365Enabled]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_unref(externalEventsList).length ? (_openBlock(), _createBlock(M365NewCalEvent, {
        key: 0,
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => toggleEnableDetail(), ["prevent"])),
        class: "custom-shadow"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(M356Cal, {
        onClick: _cache[5] || (_cache[5] = _withModifiers($event => toggleEnableDetail(), ["prevent"])),
        class: "custom-shadow"
      })]))], 512), [[_vShow, vm.isM365Enabled]])]), vm.showEnableDetail ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(M365Detail, {
        onCreateNewTimeEntry: createNewTimeEntry,
        onOpenEntryEditor: editTimeEntry
      })])) : _createCommentVNode("", true), vm.M365Settings && !m365Loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[34] || (_cache[34] = _createElementVNode("span", {
        class: "block text-lg"
      }, "M365 Settings", -1)), _cache[35] || (_cache[35] = _createElementVNode("div", {
        class: "py-2 pr-4"
      }, " Integrate LeanLaw with Microsoft 365 to receive calendar events and add them to LeanLaw as time entries. Save time and enjoy a synchronized experience across commonly-used tools. ", -1)), _createElementVNode("div", _hoisted_14, [_createVNode(LlSwitch, {
        "model-value": vm.isM365Enabled,
        onChange: _cache[6] || (_cache[6] = $event => vm.showDisableDialog = true)
      }, null, 8, ["model-value"]), _createElementVNode("div", {
        class: "py-1 px-1 cursor-pointer",
        onClick: _cache[7] || (_cache[7] = _withModifiers($event => vm.showDisableDialog = true, ["prevent"]))
      }, [...(_cache[33] || (_cache[33] = [_createTextVNode(" Enabled ", -1), _createElementVNode("div", {
        class: "py-1 px-1"
      }, null, -1)]))])])])) : _createCommentVNode("", true), vm.showEnableModel ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(EnableM365, {
        onCancel: _cache[8] || (_cache[8] = $event => toggleEnableModel())
      })])) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
        modelValue: vm.showDisableDialog,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => vm.showDisableDialog = $event),
        width: "552"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "px-4"
        }, {
          append: _withCtx(() => [_createVNode(_component_v_icon, {
            onClick: _cache[9] || (_cache[9] = _withModifiers($event => vm.showDisableDialog = false, ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_cache[42] || (_cache[42] = _createElementVNode("div", {
            class: "text-center text-2xl font-semibold"
          }, " Disable Microsoft 365 ", -1)), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_v_card, {
              class: "elevation-2 transition-swing rounded-md"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(LLLogo)])]),
              _: 1
            }), _createElementVNode("div", _hoisted_18, [_createVNode(_component_v_icon, {
              size: "40"
            }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("mdi-close-circle", -1)]))]),
              _: 1
            })]), _createVNode(_component_v_card, {
              class: "elevation-2 transition-swing rounded-md"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(M356Logo)])]),
              _: 1
            })]), _cache[38] || (_cache[38] = _createElementVNode("div", {
              class: "text-center px-12 py-2"
            }, " This will revoke all permissions and authorisations for the Microsoft 365 app. ", -1)), _cache[39] || (_cache[39] = _createElementVNode("div", {
              class: "text-center font-medium px-8 py-2"
            }, " Are you sure you want to disable Microsoft 365? ", -1))]),
            _: 1
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: "outlined",
              size: "small",
              onClick: _cache[10] || (_cache[10] = _withModifiers($event => vm.showDisableDialog = false, ["prevent"]))
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode(" Skip ", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              variant: "flat",
              size: "small",
              color: "error",
              class: "mr-2",
              onClick: _cache[11] || (_cache[11] = _withModifiers($event => disableM365(), ["prevent"]))
            }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode(" Disable ", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), vm.loading && !isResizing.value ? (_openBlock(), _createBlock(Loader, {
        key: 3,
        what: 'Entries',
        class: "mt-32 flex justify-center w-full bg-white"
      })) : (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: _normalizeClass(["pl-4 p-4 transition-all duration-300 ease-in-out", getMainContentClass.value])
      }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_unref(features).timeEntriesTab && !isFirmInTrial.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(LlSwitch, {
        "model-value": true,
        onChange: toggleOldTimeEntryUi
      })]), _cache[43] || (_cache[43] = _createElementVNode("div", {
        class: "px-3 py-2 text-sm font-medium flex items-center"
      }, " Try the new time entries experience ", -1))])) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
        "data-cy": "filters-toggle-button",
        size: "small",
        class: "mr-2",
        "append-icon": "mdi-filter-variant",
        variant: "outlined",
        id: "insight-view",
        onClick: _cache[13] || (_cache[13] = _withModifiers($event => vm.showFilters = !vm.showFilters, ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[44] || (_cache[44] = [_createTextVNode(" Filters ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        size: "small",
        "append-icon": "mdi-chart-timeline-variant-shimmer",
        class: "ml-2",
        variant: "outlined",
        "data-cy": "insights-toggle",
        onClick: _cache[14] || (_cache[14] = _withModifiers($event => switchToInsightsHome(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [_createTextVNode(" Insight ", -1)]))]),
        _: 1
      })]), _createElementVNode("div", null, [_unref(features)?.enableTimeEntryShortcuts ? (_openBlock(), _createBlock(LlTooltip, {
        key: 0,
        text: _unref(getShortcutTooltip)('new_entry', 'Create a new time entry'),
        location: "top"
      }, {
        activator: _withCtx(() => [_createVNode(LlSecondaryButton, {
          variant: "flat",
          "prepend-icon": "mdi-plus",
          color: "primary",
          "data-cy": "create-time-entry-button",
          onBtnClick: _cache[15] || (_cache[15] = () => {
            createNewTimeEntry({
              isBulkCreate: true
            });
          }),
          tabindex: "0"
        }, {
          default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode(" Create Entry ", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["text"])) : (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 1,
        variant: "flat",
        "prepend-icon": "mdi-plus",
        color: "primary",
        "data-cy": "create-time-entry-button",
        onBtnClick: _cache[16] || (_cache[16] = () => {
          createNewTimeEntry({
            isBulkCreate: true
          });
        }),
        tabindex: "0"
      }, {
        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createTextVNode(" Create Entry ", -1)]))]),
        _: 1
      }))])])]), vm.showFilters ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", {
        class: _normalizeClass(["grid gap-2", filterGridClass.value])
      }, [_createElementVNode("div", _hoisted_26, [_createVNode(DateRangeSelect, {
        "default-range": 'Time Period',
        "initial-range": initialDateRange.value,
        onDateRangeFilter: dateRangeFilterChanged,
        "data-cy": "filter-date-range"
      }, null, 8, ["initial-range"])]), _createElementVNode("div", {
        class: "px-2",
        style: _normalizeStyle(hasOptionalFilters.value ? '' : 'grid-column: span 2;')
      }, [_createVNode(ClientMatterSearch, {
        ref_key: "clientMatterSearchRef",
        ref: clientMatterSearchRef,
        horizontal: hasOptionalFilters.value ? true : false,
        emitOnAnyChange: true,
        cm: vm.filter.cm,
        "query-filter": cmQueryFilter.value,
        onMatterChange: _cache[17] || (_cache[17] = $event => matterChanged()),
        "data-cy": "client-matter-search"
      }, null, 8, ["horizontal", "cm", "query-filter"])], 4), _createElementVNode("div", {
        class: "px-2 remove-all-input-styling",
        style: _normalizeStyle(hasOptionalFilters.value ? '' : 'grid-column: span 2;')
      }, [_createElementVNode("div", {
        class: _normalizeClass(["flex", hasOptionalFilters.value ? 'flex-col' : 'flex-row'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["flex-1", hasOptionalFilters.value ? '' : 'pr-2'])
      }, [_createVNode(TimekeeperPicker, {
        form: vm.filter,
        labelClass: "pr-2 py-1 text-sm",
        clearable: true,
        disabled: !_unref(permissions).time?.createOthers,
        "data-cy": "timekeeper-filter",
        "onUpdate:form": _cache[18] || (_cache[18] = updatedForm => accountChanged(updatedForm.account))
      }, null, 8, ["form", "disabled"])], 2), _createElementVNode("div", {
        class: _normalizeClass(["flex-1", hasOptionalFilters.value ? 'pt-2' : 'pl-2'])
      }, [_createVNode(LlBilledStatusSelect, {
        modelValue: vm.filter.billed,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => vm.filter.billed = $event),
        "return-object": true,
        "data-cy": "billed-status-filter",
        onChange: reloadFromFirstPage
      }, null, 8, ["modelValue"])], 2)], 2)], 4), showLedesCodes.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(CodePicker, {
        form: vm.filter,
        horizontal: true,
        onCodeChange: handleCodeChange
      }, null, 8, ["form"])])) : _createCommentVNode("", true), _unref(customFlagLabel) || _unref(features)?.centralizedFixedFeePage || vm.fixedFeeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_unref(customFlagLabel) ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(LlCustomFlagSelect, {
        modelValue: vm.filter.customFlag,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => vm.filter.customFlag = $event),
        "return-object": true,
        searchable: true,
        onChange: reloadFromFirstPage
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _unref(features)?.centralizedFixedFeePage ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["w-full", _unref(customFlagLabel) ? 'pt-2' : ''])
      }, [_createVNode(FixedFeePicker, {
        modelValue: vm.filter.ffSelection,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => vm.filter.ffSelection = $event),
        "fixed-fee-list": vm.fixedFeeList,
        "has-matter": !!vm.filter.cm.matter?.id || !!vm.filter.cm.client?.id,
        loading: vm.ffLoading,
        "data-cy": "ff-assignment-filter",
        onChange: ffFilterChanged
      }, null, 8, ["modelValue", "fixed-fee-list", "has-matter", "loading"])], 2)) : vm.fixedFeeList.length ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["w-full", _unref(customFlagLabel) ? 'pt-2' : ''])
      }, [_createVNode(FixedFeePicker, {
        modelValue: vm.filter.charge,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => vm.filter.charge = $event),
        "fixed-fee-list": vm.fixedFeeList,
        "has-matter": true,
        "show-assignment-options": false,
        placeholder: "Select Fixed Fee",
        "data-cy": "fixed-fee-filter",
        onChange: chargeChanged
      }, null, 8, ["modelValue", "fixed-fee-list"])], 2)) : _createCommentVNode("", true), _unref(features).archivedTimeEntryFilter && !(_unref(customFlagLabel) && (_unref(features)?.centralizedFixedFeePage || vm.fixedFeeList.length)) ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: _normalizeClass(["w-full", _unref(customFlagLabel) || _unref(features)?.centralizedFixedFeePage || vm.fixedFeeList.length ? 'pt-2' : ''])
      }, [_createVNode(LlShowArchived, {
        modelValue: vm.filter.archived,
        "onUpdate:modelValue": [_cache[23] || (_cache[23] = $event => vm.filter.archived = $event), reloadFromFirstPage]
      }, null, 8, ["modelValue"])], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(features).archivedTimeEntryFilter && (_unref(customFlagLabel) && (_unref(features)?.centralizedFixedFeePage || vm.fixedFeeList.length) || !_unref(customFlagLabel) && !_unref(features)?.centralizedFixedFeePage && !vm.fixedFeeList.length) ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(LlShowArchived, {
        modelValue: vm.filter.archived,
        "onUpdate:modelValue": [_cache[24] || (_cache[24] = $event => vm.filter.archived = $event), reloadFromFirstPage]
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)], 2)])) : _createCommentVNode("", true), vm.showInsights && !vm.loading ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(InsightsHome, {
        timeFilters: vm.filter
      }, null, 8, ["timeFilters"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [_createVNode(EntryList, {
        ref_key: "entryListRef",
        ref: entryListRef,
        state: __props.state,
        tracking: __props.tracking,
        filter: vm.filter,
        headers: tableHeaders.value,
        entryLoading: vm.entryLoading,
        "left-panel-open": leftPanelOpen.value,
        "right-panel-open": vm.showEditModal,
        "is-printing": vm.isPrinting,
        "selected-entry-id": vm.params.entryId,
        "show-ledes-codes": showLedesCodes.value,
        "toggle-start-stop-times": toggleStartStopTimes,
        "toggle-internal-notes": toggleInternalNotes,
        "toggle-task-codes": toggleTaskCodes,
        "toggle-activity-codes": toggleActivityCodes,
        "toggle-short-descriptions": toggleShortDescriptions,
        "toggle-fixed-fee-column": toggleFixedFeeColumn,
        onLoadEntries: _cache[25] || (_cache[25] = $event => loadEntries()),
        onEditTimeEntry: editTimeEntry,
        onDuplicateEntry: handleDuplicateEntry,
        onClosePanels: closePanels,
        onSetPrintState: setPrintState,
        onCloseEditPanel: handleCloseEditPanel,
        onPageSizeChange: savePageSize,
        onFiltersChanged: reloadFromFirstPage
      }, null, 8, ["state", "tracking", "filter", "headers", "entryLoading", "left-panel-open", "right-panel-open", "is-printing", "selected-entry-id", "show-ledes-codes"])])], 2)), _createVNode(_Transition, {
        name: "slide-panel",
        "enter-active-class": "slide-panel-enter-active",
        "leave-active-class": "slide-panel-leave-active",
        "enter-from-class": "slide-panel-enter-from",
        "enter-to-class": "slide-panel-enter-to",
        "leave-from-class": "slide-panel-leave-from",
        "leave-to-class": "slide-panel-leave-to"
      }, {
        default: _withCtx(() => [vm.showEditModal && !vm.isModalExpanded && Object.keys(vm.params).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [vm.showEditModal && !vm.isModalExpanded && Object.keys(vm.params).length > 0 ? (_openBlock(), _createBlock(EditEntry, {
          ref_key: "editEntryRef",
          ref: editEntryRef,
          key: `edit-entry-${vm.params.entryId || 'new'}`,
          state: __props.state,
          rootScope: __props.rootScope,
          alerts: __props.alerts,
          snippetService: __props.snippetService,
          stateParams: __props.stateParams,
          params: vm.params,
          entryEditService: __props.entryEditService,
          tracking: __props.tracking,
          isPanel: true,
          showExpandButton: true,
          isTimeEntryPage: true,
          angularClientMatterManager: __props.clientMatterManager,
          onAddOrEditEntry: _cache[26] || (_cache[26] = $event => addOrEditEntry($event)),
          onClose: closeEditPanel,
          onExpand: _cache[27] || (_cache[27] = $event => expandModal($event)),
          class: "p-1 mt-1"
        }, null, 8, ["state", "rootScope", "alerts", "snippetService", "stateParams", "params", "entryEditService", "tracking", "angularClientMatterManager"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(timeEntryModal, {
        modelValue: vm.isModalExpanded,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => vm.isModalExpanded = $event),
        state: __props.state,
        rootScope: __props.rootScope,
        alerts: __props.alerts,
        snippetService: __props.snippetService,
        stateParams: vm.params,
        params: vm.params,
        entryEditService: __props.entryEditService,
        tracking: __props.tracking,
        clientMatterManager: __props.clientMatterManager,
        isTimeEntryPage: true,
        onAddOrEditEntry: _cache[29] || (_cache[29] = $event => addOrEditEntry($event)),
        onClose: closeExpandedModal,
        onMinimize: _cache[30] || (_cache[30] = $event => minimizeModal($event))
      }, null, 8, ["modelValue", "state", "rootScope", "alerts", "snippetService", "stateParams", "params", "entryEditService", "tracking", "clientMatterManager"])])])]);
    };
  }
});